<template>
  <div>
    <v-switch
      v-model="config.enabled"
      label="فعال‌سازی شناسه کیوار روی کارت"
      color="primary"
    ></v-switch>

    <v-slide-y-transition>
      <div v-if="config.enabled" class="mt-4">
        <v-row>
          <v-col cols="12" sm="12">
            <v-switch
              v-model="config.usePersianDigits"
              label="نمایش اعداد به صورت فارسی"
              color="primary"
              hide-details
              class="mt-0"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="6">
            <v-slider
              v-model="config.fontSize"
              min="10"
              max="150"
              label="اندازه فونت"
              thumb-label
            ></v-slider>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="config.fontFamily"
              :items="['Arial', 'Tahoma', 'Vazirmatn', 'Times New Roman']"
              label="نوع فونت"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <color-picker
              v-model="config.backgroundColor"
              label="رنگ پس‌زمینه"
              size="100%"
            />
          </v-col>
          <v-col cols="12" md="6">
            <color-picker v-model="config.color" label="رنگ متن" size="100%" />
          </v-col>
        </v-row>
      </div>
    </v-slide-y-transition>
  </div>
</template>

<script>
import ColorPicker from "@/view/pages/qrland/components/colorPicker";

export default {
  components: { ColorPicker },
  name: "LabelSettings",
  props: {
    value: { type: Object, required: true },
  },
  computed: {
    config: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
